<template>
  <DsButtonGroup
    ref="periodSelector"
    dense
    :values="periodLabelList"
    class="period-buttons"
    @change="onChange"
  />
</template>

<script>
import { DsButtonGroup } from '@ds/components';

export default {
  name: 'PeriodSelector',
  components: {
    DsButtonGroup,
  },
  props: {
    periodList: {
      type: Array,
      default() {
        return [
          {
            label: 'Dia',
            value: 'DAY',
          },
          {
            label: 'Semana',
            value: 'WEEK',
          },
          {
            label: 'Mês',
            value: 'MONTH',
          },
        ];
      },
    },
    defaultPeriodActive: {
      type: Number,
      required: true,
    },
    periodStateName: {
      type: String,
      required: true,
    },
  },
  computed: {
    periodLabelList() {
      return this.periodList.map(p => p.label);
    },
  },
  mounted() {
    this.changePeriodByDateRange(this.defaultPeriodActive);
  },
  methods: {
    changePeriodByDateRange(periodActive) {
      const periodComponent = this.$refs.periodSelector;

      if (periodComponent) {
        const periodActiveValue = this.periodList.find((_, index) => index === periodActive).value;

        periodComponent.activatedIndex = periodActive;
        this.changePeriod(periodActiveValue);
      }
    },
    onChange(params) {
      const periodSelected = this.periodList.find(p => p.label === params.label).value;

      this.$emit('onPeriodChange', { ...params, periodSelected });
      this.changePeriod(periodSelected);
    },
    changePeriod(period) {
      this.$store.dispatch(`charts/add${this.periodStateName}Period`, period);
    },
  },
};
</script>

<style lang="scss" scoped>
.period-buttons {
  margin-bottom: var(--ds-spacing-stack-md);
}
</style>
